import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding-top: 20px;
  position: relative;

  /* Keep the requirements banner from overlapping the absolute Edit button.
     Note: this app configures antd with prefixCls="ui", so the class is
     .ui-alert, not .ant-alert. */
  .ui-alert {
    margin-top: 12px;
  }
`;

export const Edit = styled.a`
  line-height: 1;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 1;
`;
